import { render, staticRenderFns } from "./PropertyInfo.html?vue&type=template&id=0e60c241&scoped=true&"
import script from "./PropertyInfo.ts?vue&type=script&lang=ts&"
export * from "./PropertyInfo.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/properties/_info.scss?vue&type=style&index=0&id=0e60c241&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e60c241",
  null
  
)

export default component.exports